<div class="flex flex-col w-full h-full bg-white rounded-2xl overflow-hidden">
    <!-- Header -->
    <div class="flex justify-between items-center px-6 py-5 border-b border-gray-200">
        <h2 class="text-[20px] font-semibold font-inter text-gray-900 m-0">Adicionar Cartão</h2>
        <button mat-icon-button (click)="closeModal()" class="w-9 h-9 text-gray-500 hover:bg-gray-100 hover:text-gray-900 transition-all duration-200">
            <mat-icon class="icon-size-6" [svgIcon]="'mat_outline:close'"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <div class="flex-1 p-6 pb-[86px] overflow-y-auto">
        <!-- Número do Cartão (Stripe Element) -->
        <div class="stripe-field !mt-0" [class.stripe-field-invalid]="cardNumberError">
            <label class="stripe-label">Número do cartão</label>
            <div class="stripe-input-container">
                <mat-icon class="icon-size-5 stripe-icon" [svgIcon]="'mat_solid:credit_card'"></mat-icon>
                <div id="card-number-element" class="stripe-element"></div>
            </div>
            <span class="stripe-error" *ngIf="cardNumberError">{{ cardNumberError }}</span>
        </div>

        <!-- Nome no Cartão (input normal) -->
        <mat-form-field class="w-full">
            <mat-label>Nome no cartão</mat-label>
            <input
                matInput
                type="text"
                [(ngModel)]="cardName"
                placeholder="NOME NO CARTÃO"
                style="text-transform: uppercase;">
            <mat-icon class="icon-size-5" matPrefix [svgIcon]="'mat_outline:person'"></mat-icon>
        </mat-form-field>

        <!-- Validade e CVV (Stripe Elements) -->
        <div class="flex gap-4">
            <div class="stripe-field flex-1" [class.stripe-field-invalid]="cardExpiryError">
                <label class="stripe-label">Validade</label>
                <div class="stripe-input-container">
                    <mat-icon class="icon-size-5 stripe-icon" [svgIcon]="'mat_outline:calendar_today'"></mat-icon>
                    <div id="card-expiry-element" class="stripe-element"></div>
                </div>
                <span class="stripe-error" *ngIf="cardExpiryError">{{ cardExpiryError }}</span>
            </div>

            <div class="stripe-field flex-1" [class.stripe-field-invalid]="cardCvcError">
                <label class="stripe-label">CVV</label>
                <div class="stripe-input-container">
                    <mat-icon class="icon-size-5 stripe-icon" [svgIcon]="'mat_outline:lock'"></mat-icon>
                    <div id="card-cvc-element" class="stripe-element"></div>
                </div>
                <span class="stripe-error" *ngIf="cardCvcError">{{ cardCvcError }}</span>
            </div>
        </div>

        <!-- Definir como padrão -->
        <div class="mt-4">
            <mat-checkbox [(ngModel)]="setAsDefault" color="primary">
                <span class="text-[14px] font-inter text-gray-700">Definir como cartão padrão</span>
            </mat-checkbox>
        </div>
    </div>

    <!-- Footer -->
    <div class="absolute flex bottom-0 left-0 right-0 p-6 w-full flex-row-reverse bg-white border-t border-gray-200">
        <div class="relative h-[38px]">
            <button
                [disabled]="!isFormValid() || loading"
                (click)="addCard()"
                class="h-full flex px-6 py-2 rounded-3xl bg-[#0061ff] hover:bg-[#2f75e7] relative cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">
                <span class="mr-2 font-remote font-[400] text-[15px] text-white" *ngIf="!loading">Adicionar</span>
                <mat-icon class="icon-size-5 text-white relative" [svgIcon]="'mat_solid:add'" *ngIf="!loading"></mat-icon>
                <mat-progress-spinner *ngIf="loading" [diameter]="18" [mode]="'indeterminate'" class="m-auto spinner-white"></mat-progress-spinner>
            </button>
        </div>
    </div>
</div>
